<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-input-field
				formControlName="vin"
				[label]="'vehicles|record|details-section|field-label|vin'" />

			<app-input-field
				formControlName="licensePlate"
				[label]="'vehicles|record|details-section|field-label|license-plate'" />
		</div>
		@if (recordData()?.type !== vehicleTypeEnum.BICYCLE) {
			<div>
				<app-input-field
					formControlName="engineNumber"
					[label]="
						'vehicles|record|details-section|field-label|engine-number'
					" />
				<app-single-dropdown
					formControlName="allocation"
					[label]="'vehicles|record|details-section|field-label|allocation'"
					[selectOptions]="allocationType" />
			</div>
			<app-more-sections
				label="vehicles|record|details-section|group|specification">
				<div>
					<app-input-field
						formControlName="seats"
						[label]="'vehicles|record|details-section|field-label|seats'"
						[isNumber]="true" />
					<app-input-field
						formControlName="doors"
						[label]="'vehicles|record|details-section|field-label|doors'"
						[isNumber]="true" />
				</div>
				<div>
					<app-single-dropdown
						formControlName="odometerUnit"
						[label]="
							'vehicles|record|odometer-section|field-label|odometer-unit'
						"
						[selectOptions]="odometerUnit" />
					<app-single-dropdown
						formControlName="steeringPosition"
						[label]="
							'vehicles|record|details-section|field-label|steering-position'
						"
						[selectOptions]="steeringPosition" />
				</div>
				<div>
					<app-single-dropdown
						formControlName="fuelType"
						[label]="'vehicles|record|details-section|field-label|fuel-type'"
						[selectOptions]="fuelType" />
				</div>
			</app-more-sections>

			<app-more-sections
				label="vehicles|record|details-section|group|registration">
				<div>
					<app-datetime-picker
						formControlName="registeredAt"
						[label]="
							'vehicles|record|details-section|field-label|registered-at'
						"
						[showTime]="false"
						[excludeFutureDates]="true" />

					<app-datetime-picker
						formControlName="deregisteredAt"
						[label]="
							'vehicles|record|details-section|field-label|deregistered-at'
						"
						[showTime]="false"
						[excludeFutureDates]="true" />
				</div>
			</app-more-sections>

			<app-more-sections label="vehicles|record|details-section|group|tracking">
				<div>
					<app-toggle-new
						formControlName="hasGpsTracker"
						[label]="
							'vehicles|record|details-section|field-label|has-gps-tracker'
						">
					</app-toggle-new>
					@if (this.detailsForm.controls.hasGpsTracker.value === true) {
						<app-input-field
							formControlName="gpsTrackerUuid"
							[label]="
								'vehicles|record|details-section|field-label|gps-tracker-id'
							" />
					}
				</div>
			</app-more-sections>
		}
	</form>
</app-section-wrapper-container>
